import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCamera1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCamera1"><Path fillRule="evenodd" clipRule="evenodd" d="M7.09861 6L9.09861 3H14.9014L16.9014 6H22V21H2V6H7.09861ZM12 9C10.067 9 8.5 10.567 8.5 12.5C8.5 14.433 10.067 16 12 16C13.933 16 15.5 14.433 15.5 12.5C15.5 10.567 13.933 9 12 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCamera1;
